// extracted by mini-css-extract-plugin
module.exports = {"designManagerBubbleDiv":"_35a94d40","bubble":"_ca96645a","icon":"_fc62286f","printLink":"_2c26f215"};